// "Call to book" (23 Oct 2026, mock CallBook_1): customers who would rather talk call us and
// we book the trip for them. Made quiet on 24 Oct (mock Home_1 change 3): one grey line
// under the trip card, no digits on the page - the phone dials. A laptop gets the same
// line under the trip bar, and the number in its top bar.
import { CALL_NUMBER, prettyNumber } from "../../utils/contactNumbers";
import { track } from "../../utils/analytics";
import { Icon } from "../Icon";

function QuietLine({ t, from, className }) {
  return (
    <p className={className}>
      {t("cb_quiet")} ·{" "}
      <a href={`tel:+91${CALL_NUMBER}`} onClick={() => track("call_to_book_tapped", { from })}
        className="inline-flex items-center gap-1 py-1 font-extrabold text-[#3F5E00] whitespace-nowrap">
        <Icon name="phone" size={12} stroke="#5E8700" strokeWidth={2.4} />{t("cb_callUs")}
      </a>
    </p>
  );
}

export function CallToBookBar({ t, from }) {
  return <QuietLine t={t} from={from} className="lg:hidden mt-1.5 text-center text-[10.5px] text-[#64748B] leading-snug" />;
}

export function CallToBookLine({ t, from }) {
  return <QuietLine t={t} from={from} className="mt-3 text-[13px] text-[#64748B]" />;
}

/* Under Call on a car's or a driver's page. */
export function WantUsToBook({ t, from }) {
  return (
    <a href={`tel:+91${CALL_NUMBER}`} onClick={() => track("call_to_book_tapped", { from })}
      className="flex items-center justify-center gap-1.5 min-h-[40px] rounded-2xl border border-[#D6E6B0] bg-[#F8FBF1] text-[12px] font-bold text-[#3F5E00]">
      {t("cb_want")} <span className="font-extrabold whitespace-nowrap">📞 {prettyNumber(CALL_NUMBER)}</span>
    </a>
  );
}
